import DocumentTitle from "react-document-title";
import Header from "../Components/Header";
import Error from "./Error";
import { analyticsLogEvent } from "../../data/firebase/analytics";

interface ErrorProps {
  message?: string;
}

export default function ErrorPage({ message }: ErrorProps) {
  analyticsLogEvent("error_rendered", { error: message });
  return (
    <DocumentTitle title="Error">
      <>
        <Header />
        <Error message={message} />
      </>
    </DocumentTitle>
  );
}
